// @flow

import {
  SET_ACTIVE_FILTER, SET_FILTER_VALUE, SET_FILTER_VALUES, GO_BACK
} from './constants';

import type { Action } from '../types';

export const setActiveFilter = (filterKey: string): Action => ({
  type: SET_ACTIVE_FILTER,
  filterKey
});

export const setFilterValue = (filterKey: string, filterValue: string): Action => ({
  type: SET_FILTER_VALUE,
  filterKey,
  filterValue
});

export const setFilterValues = (filterValues: { [string]: any }): Action => ({
  type: SET_FILTER_VALUES,
  filterValues
});

export const goBack = (): Action => ({
  type: GO_BACK
});
